<template>
  <Popper
    placement="top"
    :hover="true"
    :arrow="true"
    offset-distance="6"
  >
    <button>
      <carrier-badge
        :is-header-show="isHeaderShow"
        :highway-status="highwayStatus"
        :connection-status="connectionStatus"
        @popper-message-sent="setPopperMessage"
      />
    </button>
    <template #content>
      <div
        class="rounded-md px-2 py-1 text-left text-xs leading-tight"
        :class="[
          contentClass,
          { 'w-40': isHeaderShow, 'max-w-39': !isHeaderShow },
        ]"
      >
        {{ popperMessage }}
      </div>
    </template>
  </Popper>
</template>

<script>
import { defineComponent } from 'vue';
import Popper from 'vue3-popper';
import CarrierBadge from '@/components/CarrierBadge.vue';

export default defineComponent({
  components: {
    Popper,
    CarrierBadge,
  },
  props: {
    colorScheme: {
      type: String,
      required: false,
      default: 'dark',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    isHeaderShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    highwayStatus: {
      type: String,
      required: false,
      default: '',
    },
    connectionStatus: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      popperMessage: '',
    };
  },
  computed: {
    iconColorClass() {
      if (this.colorScheme == 'light') {
        return 'text-light-gray';
      } else {
        return 'text-dark-gray';
      }
    },
    contentClass() {
      if (this.colorScheme == 'light') {
        return 'text-dark-gray bg-light-gray';
      } else {
        return 'text-light-gray bg-dark-gray';
      }
    },
    hasTitle() {
      if (this.title != null && this.title?.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    setPopperMessage(msg) {
      this.popperMessage = msg;
    },
  },
});
</script>

<style scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 16px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
